import type { ApprovalResponse } from '@common/types';
import { create } from 'zustand';
import { getIntakeFormStatus } from '@/services/EmailApprovalService';

export type UseClientApprovalPageStoreType = {
    isLoading: boolean;
    approvalStatusData: ApprovalResponse;
    statusOfApprovalEmail: ApprovalResponse | undefined;
    intakeFormStatus: ApprovalResponse | undefined;
    approvalConfirmationStepper: number;
    acceptLoading: boolean;
    onChangeValues: (key: keyof UseClientApprovalPageStoreType, value: any) => void;
    fetchIntakeFormStatus: (instanceId?: string, prospectId?: string) => Promise<void>;
};

const useClientApprovalPageStore = create<UseClientApprovalPageStoreType>((set) => ({
    isLoading: false,
    approvalStatusData: { Message: '', Status: '' },
    statusOfApprovalEmail: undefined,
    intakeFormStatus: undefined,
    approvalConfirmationStepper: 0,
    acceptLoading: false,
    onChangeValues: (key: keyof UseClientApprovalPageStoreType, value: any) => {
        set((state) => ({
            ...state,
            [key]: value,
        }));
    },
    fetchIntakeFormStatus: async (instanceId?: string, prospectId?: string) => {
        if (instanceId && prospectId) {
            try {
                const intakeStatusResp = await getIntakeFormStatus(instanceId, prospectId);
                set({ intakeFormStatus: intakeStatusResp.data });
            } catch (error: any) {
                console.error(error);
                set({
                    intakeFormStatus: {
                        Status: error?.response?.data?.Status || 'Failed',
                        Message: error?.response?.data?.Message,
                    },
                });
            }
        }
    },
}));

export default useClientApprovalPageStore;
